import React, { useEffect, useState } from "react";
import { useLoading } from "./LoadingContext";
import "../css/Loading.css";

import ClipLoader from "react-spinners/HashLoader";

const Loading = () => {
  const { isLoading, loadingText } = useLoading();
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    let timeout;
    if (!isLoading) {
      timeout = setTimeout(() => {
        setIsHidden(true);
      }, 1000);
    } else {
      setIsHidden(false);
    }
    return () => clearTimeout(timeout);
  }, [isLoading]);

  return (
    <div className={`loading-screen dark:bg-black/80 ${isLoading ? "" : "hidden"} ${isHidden ? "display-none" : ""}`}>
      {loadingText?.length > 0 ?
        <ClipLoader
          className="loading-spinner"
          color="blue"
          loading={isLoading}
          radius={10}
          size={50}
          speedMultiplier={1.3}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        :
        <>
          <img
            className="loading-truck"
            src={process.env.PUBLIC_URL + "/logo-load.png"}
            alt=""
          />
          <img
            className="loading-arrow"
            src={process.env.PUBLIC_URL + "/logo-arrow.png"}
            alt=""
          />
        </>
      }

      {loadingText && <p className="loading-text">{loadingText}</p>}
    </div>
  );
};

export default Loading;
